import { parseAdminRoute, parseSongRoute, useLocation } from "./hooks/useLocation";
import { NotificationProvider } from "./notifications/NotificationProvider";
import { AdminPage } from "./pages/AdminPage";
import { HomePage } from "./pages/HomePage";
import { SongPage } from "./pages/SongPage";

export default function App() {
  const { pathname, navigate } = useLocation();
  const adminRoute = parseAdminRoute(pathname);
  const songRoute = parseSongRoute(pathname);
  return (
    <NotificationProvider>
      {adminRoute ? (
        <AdminPage />
      ) : songRoute ? (
        <SongPage jobId={songRoute.jobId} onBack={() => navigate("/")} />
      ) : (
        <HomePage />
      )}
    </NotificationProvider>
  );
}
